import { useEffect, useState } from 'react';

const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}
